import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-109">
      <div className="max-w-4xl mx-auto text-center" data-id="element-110">
        {/* Logo */}
        <div className="text-[#B87AFF] text-3xl font-black tracking-widest mb-8" data-id="element-111">
          🧘 PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-112">
          El próximo domingo podés seguir buscando en internet.
        </h2>
        <p className="text-[#B87AFF] text-2xl sm:text-3xl font-black mb-10" data-id="element-113">
          O podés tener todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#1a0a2e] border border-[#B87AFF]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-114">
          <div className="p-4 bg-[#0d0a1a] border-b border-[#B87AFF]/30 text-center font-bold text-white" data-id="element-115">
            ¿Cuánto cuesta NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-[#0d0a1a] border-b border-[#B87AFF]/30" data-id="element-116">
            <div className="p-4 font-bold text-gray-400 text-center" data-id="element-117">
              Sin MegaPack Yoga Listo
            </div>
            <div className="p-4 font-bold text-[#B87AFF] text-center sm:border-l border-[#B87AFF]/30" data-id="element-118">
              Con MegaPack Yoga Listo
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-119">
            <div className="p-4 text-gray-400 text-sm" data-id="element-120">
              120 hs/año planificando desde cero
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-121">
              10 min/semana. El resto es enseñar.
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-122">
            <div className="p-4 text-gray-400 text-sm" data-id="element-123">
              Correcciones improvisadas → mismo error por meses
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-124">
              120+ guiones exactos → se resuelve en la clase
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-125">
            <div className="p-4 text-gray-400 text-sm" data-id="element-126">
              70% de abandono antes del año
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-127">
              Sistema de retención → tasa +85%
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-128">
            <div className="p-4 text-gray-400 text-sm" data-id="element-129">
              Sin material diferenciado por nivel
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-130">
              6 tomos con progresión → avanzan y recomiendan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-131">
            <div className="p-4 text-gray-400 text-sm" data-id="element-132">
              Savasana siempre igual y sin profundidad
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-133">
              60 guiones de meditación → la parte más esperada de la clase
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-134">
            <div className="p-4 text-gray-400 text-sm" data-id="element-135">
              Talleres organizados sin sistema ni rentabilidad
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-136">
              8 tipos de taller + calculadora + cronograma exacto
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-137">
            <div className="p-4 text-gray-400 text-sm" data-id="element-138">
              Sin identidad visual profesional
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-139">
              Identidad premium que justifica cobrar más
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-140">
            <div className="p-4 text-gray-400 text-sm" data-id="element-141">
              Contratos verbales que terminan en conflicto
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-142">
              Kit completo de documentos legales firmados
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-143">
            <div className="p-4 text-gray-400 text-sm" data-id="element-144">
              Alumnos que no saben cuándo "suben de nivel"
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-145">
              Sistema de evaluación → el alumno ve su progreso solo
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-146">
            <div className="p-4 text-gray-400 text-sm" data-id="element-147">
              Inversiones y posturas avanzadas sin protocolo
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#B87AFF]/5 sm:border-l border-gray-800" data-id="element-148">
              Protocolo de 6 etapas → ninguna lesión por apuro
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-149">
          <p className="text-white font-bold mb-4" data-id="element-150">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-151" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-152">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-153">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-154">
          <div className="bg-[#0a0a0a] border border-[#B87AFF]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-155">
            <div className="text-2xl mb-2" data-id="element-156">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-157">MEGAPACK YOGA LISTO</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-158">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-159">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-160">
                Antes: $34.990 ARS
              </p>
              <p className="text-[#B87AFF] text-2xl font-black mb-4" data-id="element-161">
                Hoy: $19.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48181905588480:1" className="btn-green-pulse block bg-[#B87AFF] font-black py-4 rounded-lg hover:bg-[#D4A5FF] transition-colors text-sm text-[#FFFFFF]" data-id="element-162">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          <div className="bg-[#0d0a1a] border-2 border-[#B87AFF] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(184,122,255,0.2)] flex flex-col" data-id="element-163">
            <div className="text-2xl mb-2" data-id="element-164">🏆</div>
            <h3 className="text-[#B87AFF] font-black mb-1" data-id="element-165">
              MEGAPACK + ESTUDIO PRO ELITE ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-1" data-id="element-166">La más elegida</p>
            <p className="text-gray-400 text-xs mb-4" data-id="element-167">
              6 Tomos + 6 Bonos + Estudio Pro Elite™
              <br data-id="element-168" />
              (gestión, marketing, precios y negocio)
            </p>
            <div className="mt-auto" data-id="element-169">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-170">
                Antes: $43.990 ARS
              </p>
              <p className="text-[#B87AFF] text-3xl font-black mb-4" data-id="element-171">
                Hoy: $27.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48181909618944:1" className="btn-green-pulse block bg-[#B87AFF] font-black py-4 rounded-lg hover:bg-[#D4A5FF] transition-colors text-sm text-[#FFFFFF]" data-id="element-172">
                → QUIERO EL MEGAPACK + ESTUDIO PRO ELITE
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-173">
          <span data-id="element-174">🔒 Pago 100% seguro</span>
          <span data-id="element-175">⚡ Acceso en 5 minutos</span>
          <span data-id="element-176">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-177">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}